<template>
  <div class="popup flex align-center justify-center">
    <div id="pop-wap" class="box">
      <img
        @click="close"
        class="close-img"
        src="@/assets/images/wap/popup/close.png"
      />
      <img class="bg-img" src="@/assets/images/wap/popup/bg.png" />
      <div class="content flex align-center">
        <div class="btns">
          <div
            class="btn"
            @click="
              link(
                'https://e.huawei.com/cn/get-price-info?ic_medium=hwdc&ic_source=ecampaign_01CHNHQ225701M&ic_content=HPDC2022',
                'feedback'
              )
            "
          >
            <img class="btn-img" src="@/assets/images/wap/popup/xq.png" />
            <div class="btn-text">反馈需求</div>
          </div>
          <div class="btn" @click="link(sy, 'sy')">
            <img class="btn-img" src="@/assets/images/wap/popup/cloud.png" />
            <div class="btn-text">我要上云</div>
          </div>
          <div
            class="btn"
            @click="
              link(
                'https://support.huawei.com/livechat/chatClient/chatbox.jsp?companyID=8981&configID=41&syslanguage=0&enterurl=public',
                'consult'
              )
            "
          >
            <img class="btn-img" src="@/assets/images/wap/popup/fa.png" />
            <div class="btn-text">产品&方案咨询</div>
          </div>
        </div>
        <!-- <div class="contact">会务咨询：+86 0755-28565555</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { $config } from "@/conf";

const { syUrl } = $config;
export default {
  name: "Popup",
  data() {
    return {
      sy: syUrl,
    };
  },
  methods: {
    link(url, type) {
      switch (type) {
        case "feedback":
          window._hw("send", "action", "index_feedback_btn_click", {});
          break;
        case "consult":
          window._hw("send", "action", "index_consultation_btn_click", {});
          break;
        case "sy":
          window._hw("send", "action", "index_go_cloud_click");
          break;
      }
      window.open(url);
    },
    close() {
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 0px 0px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-index-popup;
  .box {
    width: 560px;
    height: 350px;
    background: #ffffff;
    border: 1px solid #666666;
    position: relative;
    .close-img {
      width: 14px;
      height: 14px;
      position: absolute;
      right: 26px;
      top: 23px;
      z-index: 2;
    }
    .bg-img {
      width: 249px;
      height: 166px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    .content {
      width: 100%;
      height: 100%;
      padding: 10% 0;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .btns {
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
          width: 190px;
          height: 160px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(221, 221, 221, 1);

          &:first-child .btn-img {
            width: 45px;
            height: 46px;
          }
          .btn-img {
            width: 48px;
            height: 37px;
          }
          &:last-child .btn-img {
            width: 45px;
            height: 39px;
          }

          .btn-text {
            height: 25px;
            font-size: 16px;
            font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC";
            font-weight: 400;

            color: #000000;
            line-height: 25px;
            margin-top: 20px;
          }
        }

        .btn + .btn {
          margin-left: 43px;
        }
      }
      .contact {
        height: 28px;
        font-size: 18px;
        font-family: "Microsoft YaHei", "微软雅黑", "PingFang SC";
        font-weight: 400;

        color: #b4251e;
        line-height: 25px;
        margin-top: 35px;
      }
    }
  }
}

@media (max-width: 992px) {
  .popup {
    .box {
      width: 600px;
      height: 440px;

      .close-img {
        width: 21px;
        height: 21px;
        top: 30px;
        right: 30px;
      }

      .content {
        .btns {
          margin-top: 10px;
          height: 100%;
          flex-direction: column;

          .btn {
            width: 490px;
            height: 100px;
            margin: 9px 55px;
            flex-direction: row;
            justify-content: flex-start;
            border: 1px solid rgba(221, 221, 221, 1);

            &:first-child .btn-img {
              margin-left: 73px;
              margin-right: 55px;
              width: 45px;
              height: 46px;
            }
            .btn-img {
              margin-left: 73px;
              margin-right: 55px;
              width: 48px;
              height: 37px;
            }
            &:last-child .btn-img {
              margin-left: 73px;
              margin-right: 55px;
              width: 45px;
              height: 39px;
            }

            .btn-text {
              margin-top: 3px;
              font-size: 25px;
            }
          }

          .btn + .btn {
            margin-left: 55px;
          }
        }

        .contact {
          font-size: 28px;
          margin-top: 50px;
        }
      }
    }
  }
  @media screen and (max-aspect-ratio: 700/701) and (min-aspect-ratio: 700/701) {
    .popup {
      z-index: $z-index-popup;
      .box {
        width: 480px;
        height: 320px;

        .close-img {
          width: 21px;
          height: 21px;
          top: 30px;
          right: 30px;
        }

        .content {
          .btns {
            margin-top: 10px;

            .btn {
              width: 180px;
              height: 140px;
              .btn-text {
                margin-top: 29px;
                font-size: 18px;
              }
            }

            .btn + .btn {
              margin-left: 31px;
            }
          }

          .contact {
            font-size: 24px;
            margin-top: 50px;
          }
        }
      }
    }
  }
}
</style>
